/*
 * Card de "leve junto" do carrinho.
 *
 * Duas responsabilidades:
 *
 * 1. Recomendação. O Liquid entrega uma oferta de partida já renderizada; aqui a gente
 *    consulta o motor de recomendação da Shopify (intent=related, treinado nos pedidos
 *    da loja) para cada um dos últimos itens do carrinho e troca a oferta pela melhor
 *    encontrada. Produto que aparece nas recomendações de mais de um item do carrinho
 *    pontua mais — é assim que a sugestão passa a olhar a cesta e não um item só.
 *
 *    Só entram produtos que estejam em alguma faixa configurada. Faixa com percentual
 *    0 é indicação pura (sem desconto real); faixa > 0 precisa ter regra equivalente
 *    no admin, senão o card prometeria um desconto que o checkout não aplica.
 *
 *    Se a consulta falhar ou nada servir, a oferta do Liquid continua valendo.
 *
 * 2. Adicionar ao carrinho. O card vive dentro de <cart-drawer-items>, que o
 *    cart-drawer.js substitui inteiro a cada atualização, então o clique é delegado
 *    no documento e a recomendação roda de novo a cada card novo.
 */
(function () {
  'use strict';

  var LIMITE_POR_SEMENTE = 10;

  function formatarDinheiro(centavos) {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    }).format(centavos / 100);
  }

  function redimensionar(url, largura) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + largura;
  }

  function carrinho() {
    return document.querySelector('cart-drawer') || document.querySelector('cart-notification');
  }

  /* ---------------------------------------------------------------- recomendação */

  function lerFaixas(card) {
    var tag = card.querySelector('[data-sdn-faixas]');
    if (!tag) return {};
    try {
      return JSON.parse(tag.textContent) || {};
    } catch (e) {
      console.warn('[sdn-cart-upsell] faixas inválidas', e);
      return {};
    }
  }

  function buscarRecomendacoes(produtoId) {
    var base =
      (typeof routes !== 'undefined' && routes.product_recommendations_url) ||
      '/recommendations/products';
    var url =
      base +
      '.json?product_id=' +
      encodeURIComponent(produtoId) +
      '&intent=related&limit=' +
      LIMITE_POR_SEMENTE;

    return fetch(url)
      .then(function (r) {
        return r.ok ? r.json() : { products: [] };
      })
      .then(function (d) {
        return (d && d.products) || [];
      })
      .catch(function () {
        return [];
      });
  }

  function escolherVariante(produto) {
    var disponiveis = (produto.variants || []).filter(function (v) {
      return v.available;
    });
    return disponiveis[0] || (produto.variants || [])[0] || null;
  }

  function melhorOferta(listas, faixas, idsNoCarrinho) {
    var pontos = {};
    var porId = {};

    listas.forEach(function (produtos) {
      produtos.forEach(function (produto, posicao) {
        var id = String(produto.id);

        if (!Object.prototype.hasOwnProperty.call(faixas, id)) return;
        if (idsNoCarrinho.indexOf(',' + id + ',') !== -1) return;
        if (produto.available === false) return;
        if (!escolherVariante(produto)) return;

        // Peso pela posição: quanto mais acima na lista, mais relevante.
        // Somar entre sementes premia quem combina com a cesta toda.
        pontos[id] = (pontos[id] || 0) + (LIMITE_POR_SEMENTE - posicao);
        porId[id] = produto;
      });
    });

    var melhor = null;
    var melhorPonto = -1;
    Object.keys(pontos).forEach(function (id) {
      if (pontos[id] > melhorPonto) {
        melhorPonto = pontos[id];
        melhor = porId[id];
      }
    });

    return melhor;
  }

  function aplicarOferta(card, produto, pct) {
    var variante = escolherVariante(produto);
    if (!variante) return;

    var temDesconto = pct > 0;
    var precoCheio = variante.price;
    var precoFinal = temDesconto ? Math.round((precoCheio * (100 - pct)) / 100) : precoCheio;
    var economia = precoCheio - precoFinal;

    var img = card.querySelector('[data-sdn-imagem]');
    var titulo = card.querySelector('[data-sdn-titulo]');
    var cheio = card.querySelector('[data-sdn-preco-cheio]');
    var final = card.querySelector('[data-sdn-preco-final]');
    var selo = card.querySelector('[data-sdn-pct]');
    var poupa = card.querySelector('[data-sdn-economia]');
    var botao = card.querySelector('[data-sdn-upsell-add]');

    if (img && produto.featured_image) {
      // alt vazio de propósito: o título vem logo ao lado, então descrever a imagem
      // faria o leitor de tela repetir a mesma informação duas vezes.
      img.src = redimensionar(produto.featured_image, 160);
      img.alt = '';
    }
    if (titulo) titulo.textContent = produto.title || '';
    if (final) final.textContent = formatarDinheiro(precoFinal);

    // Faixa 0% é indicação pura: esconde risco/selo/economize em vez de mostrar
    // "0% OFF" — a recomendação pode trocar de faixa com desconto pra sem, então
    // isso não pode depender só do que o Liquid renderizou de partida.
    if (cheio) {
      cheio.hidden = !temDesconto;
      if (temDesconto) cheio.textContent = formatarDinheiro(precoCheio);
    }
    if (selo) {
      selo.hidden = !temDesconto;
      if (temDesconto) selo.textContent = pct + '% OFF';
    }
    if (poupa) {
      poupa.hidden = !temDesconto;
      if (temDesconto) poupa.textContent = 'economize ' + formatarDinheiro(economia);
    }
    if (botao) {
      botao.setAttribute('data-variant-id', variante.id);
      botao.setAttribute('aria-label', 'Adicionar ' + (produto.title || '') + ' ao carrinho');
    }

    card.setAttribute('data-origem', 'rec');
  }

  function melhorar(card) {
    if (!card || card.hasAttribute('data-sdn-processado')) return;
    card.setAttribute('data-sdn-processado', '');

    var faixas = lerFaixas(card);
    if (!Object.keys(faixas).length) return;

    var sementes = (card.getAttribute('data-sementes') || '')
      .split(',')
      .filter(Boolean);
    if (!sementes.length) return;

    var idsNoCarrinho = card.getAttribute('data-no-carrinho') || ',';

    Promise.all(sementes.map(buscarRecomendacoes)).then(function (listas) {
      var produto = melhorOferta(listas, faixas, idsNoCarrinho);
      if (produto) aplicarOferta(card, produto, faixas[String(produto.id)]);
    });
  }

  function varrer() {
    document.querySelectorAll('[data-sdn-upsell]').forEach(melhorar);
  }

  document.addEventListener('DOMContentLoaded', varrer);
  document.addEventListener('cart:dom-updated', varrer);
  if (document.readyState !== 'loading') varrer();

  /* ------------------------------------------------------------ adicionar ao carrinho */

  function mostrarErro(card, mensagem) {
    var alvo = card && card.querySelector('[data-sdn-upsell-erro]');
    if (!alvo) return;
    alvo.textContent = mensagem;
    alvo.hidden = false;
  }

  document.addEventListener('click', function (evento) {
    var botao = evento.target.closest ? evento.target.closest('[data-sdn-upsell-add]') : null;
    if (!botao || botao.disabled) return;

    evento.preventDefault();

    var card = botao.closest('[data-sdn-upsell]');
    var variantId = botao.getAttribute('data-variant-id');
    if (!variantId) return;

    var erro = card && card.querySelector('[data-sdn-upsell-erro]');
    if (erro) {
      erro.textContent = '';
      erro.hidden = true;
    }

    botao.disabled = true;
    botao.setAttribute('aria-busy', 'true');

    var alvo = carrinho();
    var dados = new FormData();
    dados.append('id', variantId);
    dados.append('quantity', 1);

    // Marca a origem para dar pra medir atribuição depois, sem aparecer pro cliente.
    dados.append(
      'properties[_sdn_upsell]',
      card && card.getAttribute('data-origem') === 'rec' ? 'recomendado' : 'padrao'
    );

    var secoes =
      alvo && typeof alvo.getSectionsToRender === 'function'
        ? alvo
            .getSectionsToRender()
            .map(function (s) {
              return s.section || s.id;
            })
            .filter(Boolean)
        : [];
    if (secoes.length) {
      dados.append('sections', secoes.join(','));
      dados.append('sections_url', window.location.pathname);
    }
    if (alvo && typeof alvo.setActiveElement === 'function') {
      alvo.setActiveElement(document.activeElement);
    }

    var url = (typeof routes !== 'undefined' && routes.cart_add_url) || '/cart/add';

    fetch(url, { method: 'POST', headers: { Accept: 'application/javascript' }, body: dados })
      .then(function (r) {
        return r.json();
      })
      .then(function (resposta) {
        if (resposta.status) {
          throw new Error(resposta.description || resposta.message || '');
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'sdn-cart-upsell',
            productVariantId: variantId,
            cartData: resposta,
          });
        }

        if (alvo && typeof alvo.renderContents === 'function') {
          alvo.renderContents(resposta);
        } else {
          window.location.reload();
        }
      })
      .catch(function (e) {
        console.error('[sdn-cart-upsell]', e);
        botao.disabled = false;
        botao.removeAttribute('aria-busy');
        mostrarErro(card, 'Não foi possível adicionar agora. Tente de novo.');
      });
  });
})();
